import React from 'react';
import { link } from '@atlaskit/adf-schema';
import { ACTION, ACTION_SUBJECT, ACTION_SUBJECT_ID, EVENT_TYPE, INPUT_METHOD } from '@atlaskit/editor-common/analytics';
import { addLink, tooltip } from '@atlaskit/editor-common/keymaps';
import { LinkAction } from '@atlaskit/editor-common/link';
import { toolbarInsertBlockMessages as messages } from '@atlaskit/editor-common/messages';
import { IconLink } from '@atlaskit/editor-common/quick-insert';
import { hideLinkToolbarSetMeta, insertLinkWithAnalytics, showLinkToolbar as _showLinkToolbar, updateLink } from './commands';
import fakeCursorToolbarPlugin from './pm-plugins/fake-cursor-for-toolbar';
import { createInputRulePlugin } from './pm-plugins/input-rule';
import { createKeymapPlugin } from './pm-plugins/keymap';
import { plugin as _plugin, stateKey } from './pm-plugins/main';
import { prependToolbarButtons, toolbarButtonsPlugin } from './pm-plugins/toolbar-buttons';
import { getToolbarConfig } from './Toolbar';
export var hyperlinkPlugin = function hyperlinkPlugin(_ref) {
  var _api$featureFlags;
  var _ref$config = _ref.config,
    options = _ref$config === void 0 ? {} : _ref$config,
    api = _ref.api;
  var featureFlags = (api === null || api === void 0 ? void 0 : (_api$featureFlags = api.featureFlags) === null || _api$featureFlags === void 0 ? void 0 : _api$featureFlags.sharedState.currentState()) || {};
  return {
    name: 'hyperlink',
    marks: function marks() {
      return [{
        name: 'link',
        mark: link
      }];
    },
    commands: {
      showLinkToolbar: function showLinkToolbar() {
        var _api$analytics;
        var inputMethod = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INPUT_METHOD.TOOLBAR;
        return _showLinkToolbar(inputMethod, api === null || api === void 0 ? void 0 : (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions);
      }
    },
    actions: {
      prependToolbarButtons: prependToolbarButtons,
      hideLinkToolbar: hideLinkToolbarSetMeta,
      insertLink: function insertLink(inputMethod, from, to, href, title, displayText) {
        var _api$analytics2;
        var cardsAvailable = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
        var sourceEvent = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : undefined;
        return insertLinkWithAnalytics(inputMethod, from, to, href, api === null || api === void 0 ? void 0 : (_api$analytics2 = api.analytics) === null || _api$analytics2 === void 0 ? void 0 : _api$analytics2.actions, title, displayText, cardsAvailable, sourceEvent);
      },
      updateLink: updateLink
    },
    getSharedState: function getSharedState(editorState) {
      if (!editorState) {
        return undefined;
      }
      return stateKey.getState(editorState);
    },
    pmPlugins: function pmPlugins() {
      var _options$cardOptions;
      // Skip analytics if card provider is available, as they will be
      // sent on handleRejected upon attempting to resolve smart link.
      var skipAnalytics = !!(options !== null && options !== void 0 && (_options$cardOptions = options.cardOptions) !== null && _options$cardOptions !== void 0 && _options$cardOptions.provider);
      return [{
        name: 'hyperlink',
        plugin: function plugin(_ref2) {
          var dispatch = _ref2.dispatch;
          return _plugin(dispatch, options === null || options === void 0 ? void 0 : options.editorAppearance);
        }
      }, {
        name: 'fakeCursorToolbarPlugin',
        plugin: function plugin() {
          return fakeCursorToolbarPlugin;
        }
      }, {
        name: 'hyperlinkInputRule',
        plugin: function plugin(_ref3) {
          var _api$analytics3;
          var schema = _ref3.schema,
            featureFlags = _ref3.featureFlags;
          return createInputRulePlugin(schema, skipAnalytics, featureFlags, api === null || api === void 0 ? void 0 : (_api$analytics3 = api.analytics) === null || _api$analytics3 === void 0 ? void 0 : _api$analytics3.actions);
        }
      }, {
        name: 'hyperlinkKeymap',
        plugin: function plugin() {
          var _api$analytics4;
          return createKeymapPlugin(skipAnalytics, api === null || api === void 0 ? void 0 : (_api$analytics4 = api.analytics) === null || _api$analytics4 === void 0 ? void 0 : _api$analytics4.actions);
        }
      }, {
        name: 'hyperlinkToolbarButtons',
        plugin: toolbarButtonsPlugin
      }];
    },
    pluginsOptions: {
      quickInsert: function quickInsert(_ref4) {
        var formatMessage = _ref4.formatMessage;
        return [{
          id: 'hyperlink',
          title: formatMessage(messages.link),
          description: formatMessage(messages.linkDescription),
          keywords: ['hyperlink', 'url'],
          priority: 1200,
          keyshortcut: tooltip(addLink),
          icon: function icon() {
            return /*#__PURE__*/React.createElement(IconLink, null);
          },
          action: function action(insert, state) {
            var _api$analytics5, _api$analytics5$actio, _api$analytics5$actio2;
            var tr = insert(undefined);
            tr.setMeta(stateKey, {
              type: LinkAction.SHOW_INSERT_TOOLBAR,
              inputMethod: INPUT_METHOD.QUICK_INSERT
            });
            var analyticsAttached = api === null || api === void 0 ? void 0 : (_api$analytics5 = api.analytics) === null || _api$analytics5 === void 0 ? void 0 : (_api$analytics5$actio = _api$analytics5.actions) === null || _api$analytics5$actio === void 0 ? void 0 : (_api$analytics5$actio2 = _api$analytics5$actio.attachAnalyticsEvent) === null || _api$analytics5$actio2 === void 0 ? void 0 : _api$analytics5$actio2.call(_api$analytics5$actio, {
              action: ACTION.INVOKED,
              actionSubject: ACTION_SUBJECT.TYPEAHEAD,
              actionSubjectId: ACTION_SUBJECT_ID.TYPEAHEAD_LINK,
              attributes: {
                inputMethod: INPUT_METHOD.QUICK_INSERT
              },
              eventType: EVENT_TYPE.UI
            })(tr);
            return analyticsAttached !== false ? tr : false;
          }
        }];
      },
      floatingToolbar: getToolbarConfig(options, featureFlags, api)
    }
  };
};